export default "__VITE_ASSET__Dicv18uc__"